import { translate } from "@kaltura/mediaspace-shared-utils";

const ALLOWED_PROTOCOLS = ["http:", "https:", "ftp:"];

const getExtension = (url: URL) => {
    const pathname = url.pathname.toLowerCase();

    // Remove trailing slash
    const cleanPath = pathname.replace(/\/$/, "");

    // Get extension (everything after last dot)
    const parts = cleanPath.split("/").pop()?.split(".") || [];

    // Return last part if it exists and has content
    return parts.length > 1 ? parts[parts.length - 1] : "";
};

export const validateUrlStructure = (url: string, allowedExtensions?: string[]): { valid: boolean; error?: string } => {
    const trimmed = url.trim();

    if (!trimmed) return { valid: false, error: translate("URL is required") };

    try {
        const parsed = new URL(trimmed);

        if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
            return { valid: false, error: translate("Invalid URL format") };
        }

        if (allowedExtensions) {
            // if only specific extensions allowed
            const ext = getExtension(parsed);

            if (!ext) {
                return { valid: false, error: translate("Invalid URL format") };
            }

            if (!allowedExtensions.includes(ext)) {
                return { valid: false, error: translate("Invalid URL format") };
            }
        }

        return { valid: true };
    }
    catch {
        return { valid: false, error: translate("Invalid URL format") };
    }
};
